import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase.js';
import {SplitText} from 'gsap/SplitText.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( CustomEase );
      gsap.registerPlugin( SplitText );

      CustomEase.create( 'fastForwardAnimation', '0.390, 0.575, 0.565, 1.000' );

      // global animations in animate will load in after running common.js init function, all component javascript, and before common.js finalize function.
      // This should improve animations loading in and fix odd start times due to load order
      /*
       * Fade on scroll
       */
      $( '.js-fade:not(.js-ignore), .js-fade-group > *:not(.js-ignore)' ).each( function() {
        ScrollTrigger.create( {
          trigger: this,
          start: 'top 90%',
          scrub: 0.15,
          onRefresh: ( self ) => {
            if ( self.progress > 0 ) {
              $( this ).addClass( 'js-animated' );
            }
          },
          onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'js-animated' ),
        } );
      } );

      /*
       * Reveal on scroll
       */
      $( '.js-reveal:not(.js-ignore)' ).each( function() {
        gsap.to( this, {
          scrollTrigger: {
            trigger: this,
            start: 'top 70%',
            scrub: false,
          },
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
          duration: .70,
          ease: 'fastForwardAnimation',
          lazy: false,
        } );
      } );
      $( '.bar-reveal:not(.js-ignore)' ).each( function( index ) {
        gsap.to( this, {
          scrollTrigger: {
            trigger: this,
            start: 'top 70%',
            scrub: false,
          },
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
          duration: .70,
          delay: 0.2 + ( index * 0.1 ),
          ease: 'fastForwardAnimation',
          lazy: false,
        } );
      } );

      // YELLOW LEFT BORDER ANIMATION
      $( '.yellow-left-border' ).each( function() {
        gsap.from( this, {
          scrollTrigger: {
            trigger: this,
            start: 'top 70%',
            scrub: false,
            // markers: true,
          },
          onStart: () => {
            this.classList.add( 'action' );
          },
        } );
      } );

      // YELLOW HIGLIGHT EFFECT / SPLIT LINE
      $( '.yellow-highlight, .yellow-highlight >*, .blue-highlight, .blue-highlight >* ' ).each( function() {
        const lineSplit = new SplitText( this, {type: 'lines'} );
        const lines = lineSplit.lines;

        // IF OTHER TAGS ARE USED INSIDE THE YELLOW-HIGHLIGHT CLASS ONLY USE THE INNER CLASSES FOR ANIMATION

        gsap.from( lines, {
          scrollTrigger: {
            trigger: lines,
            start: 'top 70%',
            scrub: false,
          },
          onStart: () => {
            if ( lines[0].childElementCount === 0 ) {
              lines.forEach( ( line, idx ) => {
                line.classList.add( 'hl-action' );
              } );
            }
          },
          stagger: {
            each: 0.15,
            from: 2,
          },
        } );
      } );
      // ARROWS FOR LISTS
      $( '.arrow-list li' ).each( function() {
        ScrollTrigger.create( {
          trigger: this,
          start: 'top 80%',
          scrub: 0.15,
          onRefresh: ( self ) => {
            if ( self.progress > 0 ) {
              $( this ).addClass( 'arrow-in-left' );
            }
          },
          onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'arrow-in-left' ),
        } );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
